//HASTRID

const OrdsApi = Object.freeze({
    QuickRequest: '/ords/hastrid/hastrid.ha_trans.get_quickrequest?i_q_id=', //j_q_url
    MenuStructure: '/ords/hastrid/hastrid.ha_trans.get_menu',
    NewsFeed: '/ords/mastra/apex_public_user.news_pkg.Get_news_items?i_site='
})

const XmlVariables = Object.freeze({
    MenuNodeName: 'HASTRIDRESULTAT'
})

export default {
    OrdsApi,
    XmlVariables
}